import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c3c7c39c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c3c7c39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c7c39c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3c7c39c')) {
      api.createRecord('c3c7c39c', component.options)
    } else {
      api.reload('c3c7c39c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c3c7c39c&scoped=true&", function () {
      api.rerender('c3c7c39c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2g8b3FT4DzEc8/JS/comp/PopupBox.vue"
export default component.exports